import type { ErrorMessageMode } from '#/axios';
import { PageEnum } from '@/enums/pageEnum';
import { router } from '@/router';
import { MessagePlugin } from 'tdesign-vue-next';
import { debounce } from 'lodash-es';
import { useUserInfoStore } from '@/store/modules/userInfo';
import { defHttp } from '.';
import { useI18n } from '@/hooks/web/useI18n';
const { t } = useI18n();
const showLogoutMessage = () => {
  // window.close()
  MessagePlugin.error(t('login.tipLoginExpired'));
  if (import.meta.env.MODE == 'web') {
    sessionStorage.removeItem('isLoginSuccess');
  }
  try {
    const store = useUserInfoStore();
    store.logoutStatus();
    router.push({
      path: PageEnum.BASE_LOGIN,
      query: { redirect: encodeURIComponent(router.currentRoute.value.fullPath) }
    });
    if (window.electron?.ipcRenderer) {
      window.electron.ipcRenderer.send('clear-history', {});
    }
  } catch (e) {
    router.push({
      path: PageEnum.BASE_LOGIN,
      query: { redirect: encodeURIComponent(router.currentRoute.value.fullPath) }
    });
    if (window.electron?.ipcRenderer) {
      window.electron.ipcRenderer.send('clear-history', {});
    }
  }
};

const showLogoutMessageDebounce = debounce(showLogoutMessage, 100);
const showLogoutMessageDebounceOnline = debounce(showLogoutMessage, 500);

const showErrorMessageDebounce = debounce((msg: string) => {
  showErrorMessage(msg);
}, 100);

const showErrorMessage = (msg: string) => {
  MessagePlugin.error(msg);
};

export function checkStatus(
  status: number,
  msg: string,
  errorMessageMode: ErrorMessageMode = 'message',
  isLocalRequest: boolean = false
): void {
  switch (status) {
    case 4002: {
      showLogoutMessageDebounce();
      return;
    }
    case 401: {
      if (isLocalRequest) {
        showLogoutMessageDebounce();
      } else {
        showLogoutMessageDebounceOnline();
      }
      return;
    }
    case 400: {
      showErrorMessageDebounce(msg);
      return;
    }
    case 888: {
      showErrorMessageDebounce(msg);
      return;
    }
  }
  // TODO: 实现不同的状态码对应的错误处理
}

export const checkLocalService = () => {
  return defHttp.request({
    method: 'head',
    url: '/api/edge/user/checkState'
  });
};
